export { default } from './NomenclatureModule';
